import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
  name: "percentagesymbol",
})
export class PercentagePipe implements PipeTransform {
  transform(value: string | number | null | undefined): string {
    if (value !== null && value !== undefined && value !== "") {
      return `${value}%`;
    }
    return "";
  }
}
